import React from 'react';
import { BundleRoute } from '@saucelabs/sl-component-router';

const importEmbeddedWrapper = () => import(/* webpackChunkName: "embedded-wrapper" */ './containers/EmbeddedWrapperContainer');


/*
 https://reacttraining.com/react-router/web/api/Route/path-string-string
 string[] as a path prop doesn't work oO
*/
const EmbeddedJobRoutes = [
  <BundleRoute
    key="job-embed"
    exact
    load={importEmbeddedWrapper}
    path="/job-embed/:jobId"
  />,
  <BundleRoute
    key="video-embed"
    exact
    load={importEmbeddedWrapper}
    path="/video-embed/:jobId"
  />,
];

export default EmbeddedJobRoutes;
export { EmbeddedJobRoutes };
